import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-managed-service-label',
  standalone: true,
  template: `
    @if (managed()) {
      <div class="label managed" title="{{ 'Managed' | translate }}">
        <span>M</span>
      </div>
    }
  `,
  imports: [TranslatePipe],
  styles: `
    .label {
      &.managed {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 1px 0 0 0;
        width: 22px;
        height: 22px;
        font-size: 100%;
        background: transparent;
        border: 1px solid #4099ff;
        color: #4099ff !important;
      }
    }
  `,
})
export class ManagedServiceLabelComponent {
  public managed = input.required<boolean>();
}
